import { Link } from '@nextui-org/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { checkType, CtyShowToast, CtySpinner } from '@circuitry-ai/doc-ui';
import { useGetExplainAnswerDetailsMutation } from '@circuitry-ai/doc-data';
import ExplainerPartsCatalogModal from './explainerPartsCatalogModal';

interface ExplainPartsCatalogAnswerProps {
    msgIndex: number;
    metadataMap: Record<string, any>;
    userQuery: string;
    advisorResponse?: string;
}

const ExplainPartsCatalogAnswer = ({
    msgIndex,
    metadataMap,
    userQuery,
    advisorResponse = ''
}: ExplainPartsCatalogAnswerProps) => {
    const { t } = useTranslation();
    const [viewExplainer, setViewExplainer] = useState<boolean>(false);
    const [getExplainAnswerDetails, { isLoading: explainerAnswerIsLoading }] = useGetExplainAnswerDetailsMutation();
    const [explainerAnswer, setExplainerAnswer] = useState<any>(null);

    const fetchExplainerAnswer = async () => {
        const messageId = metadataMap?.message_id ?? '';
        try {
            const expertAnswerResponse = await getExplainAnswerDetails(messageId).unwrap();

            // Check if this is parts catalog data by looking for the specific structure
            const responseData = expertAnswerResponse?.data;
            if (responseData?.retrieved_contexts?.headers && responseData?.retrieved_contexts?.rows) {
                setExplainerAnswer(responseData);
                setViewExplainer(true);
            } else {
                // Fallback to the old structure if needed
                setExplainerAnswer(expertAnswerResponse);
                setViewExplainer(true);
            }
        } catch (e) {
            CtyShowToast(checkType.error, (e as Error)?.message || 'Error loading explainer data');
            setViewExplainer(false);
        }
    };

    const explainerModalProps = {
        setViewExplainer,
        explainerAnswer,
        msgIndex,
        userQuery,
        metadataMap,
        advisorResponse
    };

    return (
        <>
            <Link
                id="explain-parts-catalog-answer-link"
                onPress={fetchExplainerAnswer}
                size="md"
                className="text-[#0BA5EC] font-medium cursor-pointer mt-3"
            >
                <span className={`flex ${explainerAnswerIsLoading && "gap-1"}`}>
                    <span>
                        {explainerAnswerIsLoading && <CtySpinner size="sm" />}
                    </span>
                    [Explain this answer]
                </span>
            </Link>
            {viewExplainer && explainerAnswer && (
                <ExplainerPartsCatalogModal {...explainerModalProps} />
            )}
        </>
    );
};

export default ExplainPartsCatalogAnswer; 